const insideCurlyBrackets = /{(.*?)}/g;

export const actionRegexes = {
  insideCurlyBrackets,
};
